// extracted by mini-css-extract-plugin
export default {"client_carousel":"ourClient_client_carousel__mDBs0","slick-slide":"ourClient_slick-slide__kCj7u","client_logo":"ourClient_client_logo__5xvTH"};